<template>
  <div style="margin-top: 2.75rem">
    <div v-for="(career, index) in careers" :key="career.id">
      <div v-if="!isBreakPointMedium" class="container">
        <div
          class="position-relative itb-job-offer-wrapper d-flex align-items-center"
          :class="
            index % 2 > 0 ? 'justify-content-start' : 'justify-content-end'
          "
          v-lazy:background-image="
            !!career.careerImage
              ? '/uploads/' +
                career.careerImage.path +
                '/' +
                career.careerImage.name
              : '/images/articles/blank-image-job-offer.png'
          "
        >
          <div class="itb-job-offer-text-wrapper position-absolute w-50">
            <div
              class="bg-white py-4 itb-job-offer-text"
              :class="
                index % 2 > 0 ? 'itb-job-offer-left' : 'itb-job-offer-right'
              "
            >
              <h2>{{ career.name }}</h2>
              <p>
                <span class="itb-job-offer-bold">{{
                  career.salary_text +
                  " " +
                  $t("general.from") +
                  " " +
                  career.minimumSalaryFormatted +
                  " " +
                  $t("general.currency_crowns") +
                  " " +
                  $t("general.to") +
                  " " +
                  career.maximumSalaryFormatted +
                  " " +
                  $t("general.crowns_per_month")
                }}</span>
              </p>
              <p class="mb-0" style="white-space: pre-line">
                {{ career.description }}
              </p>
              <div
                class="d-flex justify-content-between align-items-center mt-3"
              >
                <p
                  class="mb-0 itb-job-offer-bold"
                  :class="{
                    'order-0': index % 2 > 0,
                    'order-1': index % 2 == 0 && !isBreakPointLarge,
                    'itb-job-footer-order-1':
                      index % 2 == 0 && isBreakPointLarge,
                  }"
                >
                  {{ career.availability_text }}
                </p>
                <router-link
                  class="btn itb-btn-icon btn-primary"
                  :to="{
                    name: 'careerDetail',
                    params: {
                      careerAlias: career.alias,
                    },
                  }"
                >
                  {{ $t("careers.button_text") }}
                  <img
                    src="/images/icons/4soft_icon_angle-right.svg"
                    alt="career button"
                    class="itb-icon itb-angle-right-icon"
                  />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container" v-if="isBreakPointMedium">
        <div
          class="itb-job-offer-image"
          v-lazy:background-image="
            !!career.careerImage
              ? '/uploads/' +
                career.careerImage.path +
                '/' +
                career.careerImage.name
              : ''
          "
        ></div>
        <div class="itb-job-offer-text-wrapper">
          <div class="bg-white py-4 itb-job-offer-text">
            <h2>{{ career.name }}</h2>
            <p>
              <span class="itb-job-offer-bold">{{
                career.salary_text +
                " " +
                $t("general.from") +
                " " +
                career.minimumSalaryFormatted +
                " " +
                $t("general.currency_crowns") +
                " " +
                $t("general.to") +
                " " +
                career.maximumSalaryFormatted +
                " " +
                $t("general.crowns_per_month")
              }}</span>
            </p>
            <p v-html="career.description"></p>
            <div>
              <p class="itb-job-offer-bold">
                {{ career.availability_text }}
              </p>
              <router-link
                class="btn itb-btn-icon btn-primary"
                :to="'/kariera/' + career.id"
              >
                {{ $t("careers.button_text") }}
                <img
                  src="/images/icons/4soft_icon_angle-right.svg"
                  alt="career button"
                  class="itb-icon itb-angle-right-icon"
                />
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <hr
        v-if="index != careers.length - 1"
        class="position-relative itb-job-offer-divider"
      />
    </div>

    <section class="itb-hero-cards-contact itb-job-offer-contact-info">
      <div class="container">
        <h2 class="mb-0">{{ $t("contacts.career_section_title") }}</h2>
        <p class="h3 mb-3">
          {{ $t("contacts.career_section_subtitle") }}
        </p>
        <div
          class="row d-flex align-content-center mx-0 itb-bg itb-lazy-loading-bg mb-0"
          v-lazy:background-image="'/images/articles/contact-main.webp'"
        >
          <div class="col-12 col-md-8 offset-md-4 col-xl-6 offset-xl-6 p-0">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <h2>
                      {{ appParams.general_company_name }}
                    </h2>
                    <p class="m-0">
                      {{ appParams.general_company_street }}
                    </p>
                    <p class="m-0">
                      {{ appParams.general_company_city }}
                    </p>
                    <p class="m-0">
                      {{ $t("contacts.ico") }}:
                      {{ appParams.general_company_ico }}
                    </p>
                    <p class="m-0">
                      {{ $t("contacts.dic") }}:
                      {{ appParams.general_company_dic }}
                    </p>
                  </div>
                  <div class="col-12 col-md-6 pl-xl-0">
                    <h3>
                      {{ $t("contacts.email_for_job_offer") }}
                    </h3>
                    <p class="m-0">
                      <a
                        :href="
                          'mailto:' +
                          appParams.general_email +
                          '?Subject=' +
                          $t('general.email_subject')
                        "
                        itemprop="email"
                        >{{ appParams.general_email }}</a
                      >
                    </p>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <p class="m-0 itb-info" style="margin-bottom: 1rem">
                      {{ appParams.general_company_dic_text }}
                    </p>
                  </div>
                  <div class="col-12 col-md-6 pl-xl-0">
                    <h3>
                      {{ $t("contacts.or_call") }}
                    </h3>
                    <p class="m-0">
                      <a
                        :href="'tel:' + stripedPhone(appParams.general_phone)"
                        itemprop="telephone"
                        >{{ appParams.general_phone }}</a
                      >
                      <span
                        class="text-muted"
                        style="font-size: 80%; position: relative; top: -2px"
                        >{{ $t("contacts.open_hours") }}</span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      pageParams: [],
      careers: [],
      isBreakPointLarge: true,
      isBreakPointMedium: false,
      contactParams: null,
    };
  },

  created() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    axios
      .get("/getCareerPage")
      .then((response) => {
        this.pageParams = response.data.params;
        this.careers = response.data.careers;
        this.setPageParams(this.pageParams);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  computed: {
    ...mapGetters({
      appParams: "getAppParams",
    }),
  },

  methods: {
    ...mapActions(["setPageParams"]),

    onResize() {
      if (window.innerWidth >= 1570) {
        this.isBreakPointLarge = true;
      } else {
        this.isBreakPointLarge = false;
      }

      if (window.innerWidth < 992) {
        this.isBreakPointMedium = true;
      } else {
        this.isBreakPointMedium = false;
      }
    },

    stripedPhone(phone) {
      return phone ? String(phone).replace(/\s/g, "") : "";
    },
  },
};
</script>
